import React from 'react';
import PropTypes from 'prop-types';
import { Container, Row } from '@narvar/nth-grid';
import { SmallHeader } from '@narvar/nth-header';
import ReturnMethodCard from '../ReturnMethodCard';
import generateMethodKey from '../../lib/generateMethodKey';
import { formatCurrencyValue } from '../../lib/currencyFormatters';

const ReturnOptionsMethods = ({
  display,
  onClick,
  methods,
  language,
  optionId,
  selectedOptionMethodKey,
  locale,
  currencyCode,
}) => {
  const renderFee = (method, methodKey) => {
    const {
      use_method_price_label: usePriceLabel = false,
      return_cost: { return_shipping_fee: shippingFee } = {},
    } = method;

    if (methods.length === 1) {
      return '';
    } else if (usePriceLabel) {
      return language[`returns.return_options.${optionId}.${methodKey}.method_price_label`];
    } else if (shippingFee) {
      return formatCurrencyValue({ value: shippingFee, locale, currencyCode });
    }
    return language['returns.general.free_label'];
  };

  if (!display) return null;

  return (
    <Container style={{ paddingLeft: 0, paddingRight: 0 }}>
      <Row style={{ textAlign: 'center' }}>
        <SmallHeader>{language[`returns.return_options.${optionId}.instructions`]}</SmallHeader>
      </Row>
      <div
        style={{
          display: 'table',
          borderCollapse: 'separate',
          borderSpacing: '20px',
          width: '100%',
        }}
      >
        <div style={{ display: 'table-row' }}>
          {methods.map((method) => {
            const methodKey = generateMethodKey(method);
            return (
              <ReturnMethodCard
                onClick={onClick(methodKey)}
                selected={methodKey === selectedOptionMethodKey}
                carrier={method.carrier}
                singleCard={methods.length === 1}
                optionId={optionId}
                methodKey={methodKey}
                fee={renderFee(method, methodKey)}
                key={methodKey}
                optionWidth={`${100 / methods.length}%`}
              />
            );
          })}
        </div>
      </div>
    </Container>
  );
};

ReturnOptionsMethods.defaultProps = {
  display: true,
  onClick: () => {},
  optionId: '',
  selectedOptionMethodKey: '',
  currencyCode: undefined,
};

ReturnOptionsMethods.propTypes = {
  display: PropTypes.bool,
  onClick: PropTypes.func,
  optionId: PropTypes.string,
  selectedOptionMethodKey: PropTypes.string,
  methods: PropTypes.arrayOf(
    PropTypes.shape({
      return_method: PropTypes.string,
      carrier: PropTypes.string,
      return_cost: PropTypes.shape({
        return_shipping_fee: PropTypes.number,
      }),
    }),
  ).isRequired,
  language: PropTypes.object.isRequired,
  locale: PropTypes.string.isRequired,
  currencyCode: PropTypes.string,
};

export default ReturnOptionsMethods;
